import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { toast } from 'react-toastify';

interface EndpointNodeLanInterfaceProps {
  onSubmit: () => void;
  endpointNode: string;
  endpointLanEnabled: boolean;
  endpointLan?: string;
}
export const EndpointNodeLanInterface = ({
  onSubmit,
  endpointNode,
  endpointLanEnabled = false,
  endpointLan,
}: EndpointNodeLanInterfaceProps) => {
  const api = useApi();
  const [enabled, setEnabled] = React.useState(endpointLanEnabled);
  const [lanInterface, setLanInterface] = React.useState(endpointLan);

  const enLanPost = useMutation(api.configureLanInterfaceApiV1ConfigureLanInterfacePost, {
    onSuccess() {
      toast.success('Endpoint LAN configuration updated successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    enLanPost.mutate({
      node_id: endpointNode,
      enabled,
      primary_ipv4_address: lanInterface,
    });
  };

  return (
    <Box pt={2}>
      <FormControlLabel
        control={<Checkbox checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />}
        label="Enable LAN Interface"
        sx={{ mb: 4 }}
      />

      <TextField
        fullWidth
        id="endpoint-lan"
        label="Node LAN IP and subnet size"
        variant="outlined"
        value={lanInterface}
        onChange={(e) => setLanInterface(e.target.value)}
        placeholder="LAN IP address, example: 192.168.67.1/24"
        disabled={!enabled}
        autoFocus
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};
